import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description: 'Indicate to which account you wish to receive your refunds.',
    submit: 'Continue',
    title: 'Register your bank details',
  },
  fr: {
    description:
      'Indiquez sur quel compte vous souhaitez recevoir vos remboursements.',
    submit: 'Continuer',
    title: 'Enregistrez vos informations bancaires',
  },
} as const);

export default locales;
